<ng-container *ngIf="isOnManipulation; else notOnManipulation">
  <section class="manipulation_bar isOnManipulation">
    <header>
      <section class="header-section">
        <section class="header-label" tabindex="0" aria-label="Manipulation">
          <img src="../../../../../../assets/report_v2/flag_grey.svg" alt="Back to summary analysis">
          <section>
            <h2 class="inBeta">{{ 'new_entries.manipulation' | translate }}</h2>
            <span tabindex="0" aria-label="Numbers show detected/identified manipulations">{{
              'new_entries.detected_manipulations_count' | translate }}</span>
          </section>
        </section>
        <button (click)="toggleIsOnManipulation()" tabindex="0">
          <img src="../../../../../../assets/report_v2/arrow-right.svg" alt="Arrow left. Click to go to the Summary.">
        </button>
      </section>
    </header>
    <section class="manipulation-body">
      <section class="found_flags">
        <p>{{ 'new_entries.flags_found' | translate }}</p>
        <span
          [ngClass]="(totalCharReplacements + totalManipulatedImages + totalWhiteCharacters) == 0 ? 'low' : 'high'">{{
          totalCharReplacements + totalManipulatedImages + totalWhiteCharacters }}</span>
      </section>
      <section [ngClass]="(totalCharReplacements + totalManipulatedImages + totalWhiteCharacters) == 0 ? 'low' : 'high'"
        class="flag_score" tabindex="0">
        <div class="alert_img">
          <img
            [src]="(totalCharReplacements + totalManipulatedImages + totalWhiteCharacters) == 0 ? '../../../../../../assets/report_v2/check-circled-filled.svg' : '../../../../../../assets/report_v2/warning-circled-filled.svg'"
            alt="Alert icon" />
        </div>
        <h3
          [innerHTML]="'new_entries.found_manipulations' | translate:{ number: (totalCharReplacements + totalManipulatedImages + totalWhiteCharacters) }">
        </h3>
      </section>
      <section class="flags">
        <section class="flags-body">
          <section [attr.aria-expanded]="isCharReplacement" tabindex="0" class="flag charReplacement"
            [ngClass]="{'active': isCharReplacement}">
            <section (click)="openFlag('charReplacement')" class="flag-title">
              <section class="flag-count"><span class="counter">{{ totalCharReplacements }}</span></section>
              <section class="flag-body">
                <h4><img src="../../../../../../assets/report_v2/flag_blue.svg" alt=""> {{
                  'new_entries.character_replacement' | translate }}</h4>
                <p>{{ 'new_entries.character_replacement_description' | translate }}</p>
              </section>
            </section>
            <section class="found-flags" [ngClass]="!isCharReplacement ? 'closed' : ''"
              *ngIf="includedCharactersSentences.length > 0 || excludedCharactersSentences.length > 0">
              <section class="flagged-content" tabindex="0">
                <h5 class="bold" *ngIf="includedCharactersSentences.length > 0">{{ 'new_entries.content_flagged' |
                  translate }}</h5>
                <ng-container *ngFor="let sentence of includedCharactersSentences">
                  <section class="content" (click)="selectSentence($event); scrollPage(sentence.page)">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.05664 13.4095C4.05664 13.4095 4.94184 12.5243 7.59743 12.5243C10.253 12.5243 12.0234 14.2947 14.679 14.2947C17.3346 14.2947 18.2198 13.4095 18.2198 13.4095V2.78714C18.2198 2.78714 17.3346 3.67234 14.679 3.67234C12.0234 3.67234 10.253 1.90195 7.59743 1.90195C4.94184 1.90195 4.05664 2.78714 4.05664 2.78714V13.4095Z"
                        stroke="#272727" stroke-width="1.3278" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.05664 19.6059V13.4095" stroke="#272727" stroke-width="1.3278" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <section class="content-body">
                      <h6>{{ 'new_entries.flag' | translate }}</h6>
                      <p>{{ sentence.text }} </p>
                    </section>
                  </section>
                </ng-container>
                <h5 class="bold" class="excluded-content-title" *ngIf="excludedCharactersSentences.length > 0">Excluded
                  Content</h5>
                <ng-container *ngFor="let sentence of excludedCharactersSentences">
                  <section class="content excluded" (click)="selectSentence($event); scrollPage(sentence.page)">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.05664 13.4095C4.05664 13.4095 4.94184 12.5243 7.59743 12.5243C10.253 12.5243 12.0234 14.2947 14.679 14.2947C17.3346 14.2947 18.2198 13.4095 18.2198 13.4095V2.78714C18.2198 2.78714 17.3346 3.67234 14.679 3.67234C12.0234 3.67234 10.253 1.90195 7.59743 1.90195C4.94184 1.90195 4.05664 2.78714 4.05664 2.78714V13.4095Z"
                        stroke="#272727" stroke-width="1.3278" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.05664 19.6059V13.4095" stroke="#272727" stroke-width="1.3278" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <section class="content-body">
                      <h6>{{ 'new_entries.flag' | translate }}</h6>
                      <p>{{ sentence.text }} </p>
                    </section>
                  </section>
                </ng-container>

              </section>
              <section class="actionBtns" *ngIf="canEdit">
                <button class="includeCharBtn"
                  [ngClass]="(allManipulations.excludedReplacedCharacters.length == 0 && allManipulations.replacedCharacters.length == 0) ? 'disabled': ''"
                  [disabled]="allManipulations.excludedReplacedCharacters.length == 0 && allManipulations.replacedCharacters.length == 0"
                  (click)="toggleCharReplacements(allManipulations, 2)">{{ 'new_entries.toggle_characters' | translate
                  }}</button>
              </section>
            </section>
          </section>

          <section [attr.aria-expanded]="isHiddenText" tabindex="0" class="flag hiddenText"
            [ngClass]="{'active': isHiddenText}">
            <section (click)="openFlag('hiddenText')" class="flag-title">
              <section class="flag-count"><span class="counter">{{ totalWhiteCharacters }}</span></section>
              <section class="flag-body">
                <h4><img src="../../../../../../assets/report_v2/flag_blue.svg" alt="">{{ 'new_entries.hidden_text' |
                  translate }}</h4>
                <p>{{ 'new_entries.hidden_text_description' | translate }}</p>
              </section>
              <button class="flag-toggle" [ngClass]="isHiddenText ? 'rotate' : ''"
                *ngIf="includedHiddenTextSentences.length > 0 || excludedHiddenTextSentences.length > 0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 5V19" stroke="#0059B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19 12L12 19L5 12" stroke="#0059B3" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
            </section>
            <section class="found-flags" [ngClass]="!isHiddenText ? 'closed' : ''"
              *ngIf="includedHiddenTextSentences.length > 0 || excludedHiddenTextSentences.length > 0">
              <section class="flagged-content" tabindex="0">
                <h5 *ngIf="includedHiddenTextSentences.length > 0">{{ 'new_entries.content_flagged' | translate }}</h5>
                <ng-container *ngFor="let sentence  of includedHiddenTextSentences">
                  <section class="content" (click)="selectSentence($event); scrollPage(sentence.page)"
                    *ngIf="sentence.characters && sentence.characters.length > 0">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.05664 13.4095C4.05664 13.4095 4.94184 12.5243 7.59743 12.5243C10.253 12.5243 12.0234 14.2947 14.679 14.2947C17.3346 14.2947 18.2198 13.4095 18.2198 13.4095V2.78714C18.2198 2.78714 17.3346 3.67234 14.679 3.67234C12.0234 3.67234 10.253 1.90195 7.59743 1.90195C4.94184 1.90195 4.05664 2.78714 4.05664 2.78714V13.4095Z"
                        stroke="#272727" stroke-width="1.3278" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.05664 19.6059V13.4095" stroke="#272727" stroke-width="1.3278" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <section class="content-body">
                      <h6>{{ 'new_entries.flag' | translate }}</h6>
                      <p>{{ sentence.text }}</p>
                    </section>
                    <button *ngIf="canEdit" (click)="toggleWhiteCharSentence(sentence)"><img
                        src="../../../../../../assets/report_v2/close-circle.svg" alt=""></button>
                  </section>
                </ng-container>
                <h5 class="excluded-content-title" *ngIf="excludedHiddenTextSentences.length > 0">Excluded Content</h5>
                <ng-container *ngFor="let sentence of excludedHiddenTextSentences">
                  <section class="content excluded" (click)="selectSentence($event); scrollPage(sentence.page)"
                    *ngIf="sentence.characters && sentence.characters.length > 0">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.05664 13.4095C4.05664 13.4095 4.94184 12.5243 7.59743 12.5243C10.253 12.5243 12.0234 14.2947 14.679 14.2947C17.3346 14.2947 18.2198 13.4095 18.2198 13.4095V2.78714C18.2198 2.78714 17.3346 3.67234 14.679 3.67234C12.0234 3.67234 10.253 1.90195 7.59743 1.90195C4.94184 1.90195 4.05664 2.78714 4.05664 2.78714V13.4095Z"
                        stroke="#272727" stroke-width="1.3278" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.05664 19.6059V13.4095" stroke="#272727" stroke-width="1.3278" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <section class="content-body">
                      <h6>{{ 'new_entries.flag' | translate }}</h6>
                      <p>{{ sentence.text }}</p>
                    </section>
                    <button *ngIf="canEdit" (click)="toggleWhiteCharSentence(sentence)"><img
                        src="../../../../../../assets/report_v2/close-circle.svg" alt=""></button>
                  </section>
                </ng-container>
              </section>
            </section>
          </section>

          <section [attr.aria-expanded]="isImage" tabindex="0" class="flag isImage" [ngClass]="{'active': isImage}">
            <section (click)="openFlag('isImage')" class="flag-title">
              <section class="flag-count"><span class="counter">{{ totalManipulatedImages }}</span></section>
              <section class="flag-body">
                <h4><img src="../../../../../../assets/report_v2/flag_blue.svg" alt="">{{
                  'new_entries.image_in_place_of_text' | translate }}</h4>
                <p>{{ 'new_entries.image_in_place_of_text_description' | translate }}</p>
              </section>
              <button class="flag-toggle" [ngClass]="isImage ? 'rotate' : ''"
                *ngIf="redImages.length > 0 || greenImages.length > 0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 5V19" stroke="#0059B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19 12L12 19L5 12" stroke="#0059B3" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
            </section>
            <section class="found-flags" [ngClass]="!isImage ? 'closed' : ''"
              *ngIf="redImages.length > 0 || greenImages.length > 0">
              <section class="flagged-content" tabindex="0">
                <h5 *ngIf="redImages.length > 0">{{ 'new_entries.red_flags' | translate }}</h5>
                <ng-container *ngIf="redImages.length > 0">
                  <div class="content red" *ngFor="let image of redImages"
                    (click)="selectSentence($event); scrollPage(image.page + 1)">
                    <img src="../../../../../../assets/report_v2/flag_grey.svg" alt="">
                    <section class="content-body">
                      <h6>{{ 'new_entries.flag' | translate }}</h6>
                      <p>Image {{ image.index }}</p>
                    </section>
                    <button *ngIf="canEdit"><img src="../../../../../../assets/report_v2/plus-circle.svg"
                        alt="Plus Button" (click)="includeManipulatedImage(image)"></button>
                  </div>
                </ng-container>
                <h5 class="excluded-content-title" *ngIf="greenImages.length > 0">{{ 'new_entries.green_flags' |
                  translate }}</h5>
                <ng-container *ngIf="greenImages.length > 0">
                  <div class="content green" *ngFor="let image of greenImages"
                    (click)="selectSentence($event); scrollPage(image.page + 1)">
                    <img src="../../../../../../assets/report_v2/flag_grey.svg" alt="">
                    <section class="content-body">
                      <h6>{{ 'new_entries.flag' | translate }}</h6>
                      <p>Image {{ image.index }}</p>
                    </section>
                    <button *ngIf="canEdit"><img src="../../../../../../assets/report_v2/x-circle.svg" alt="X Button"
                        (click)="excludeManipulatedImage(image)"></button>
                  </div>
                </ng-container>
              </section>
              <section class="actionBtns">
                <button *ngIf="isImage" (click)="refreshPdf()" class="refresh_btn"><img
                    src="../../../../../../assets/report_v2/reload.svg" alt="Reload">{{ 'new_entries.reload_pdf' |
                  translate }}<span class="tooltip" [ngClass]="tooltipVisible ? 'visible' : ''">Click here to refresh
                    the PDF!</span></button>
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
    <app-overview-disclaimer [title]="'general.overview' | translate" tabindex="0"
      [disclaimerText]="'new_entries.manipulation_analysis' | translate"
      [disclaimerLink]="'https://support.inspera.com/hc/en-us/articles/25465385120413-Manipulation-Analysis-In-Depth'"
      [linkText]="'new_entries.learn_more' | translate"></app-overview-disclaimer>
  </section>

</ng-container>

<ng-template #notOnManipulation>
  <section class="manipulation_bar">
    <header>
      <section class="header-section">
        <section class="header-label" tabindex="0" aria-label="Manipulation">
          <img src="../../../../../../assets/report_v2/flag.svg" alt="Open Manipulation analysis">
          <section>
            <h2 class="inBeta">{{ 'new_entries.manipulation' | translate }}</h2>
            <span tabindex="0" aria-label="Numbers show detected/identified manipulations">{{
              'new_entries.detected_manipulations_count' | translate }}</span>
          </section>
        </section>
        <button (click)="toggleIsOnManipulation()" tabindex="0">
          <span>{{ 'metadata.go_to_details' | translate }}</span>
          <img src="../../../../../../assets/report_v2/arrow-right.svg"
            alt="Arrow right. Click to go to the Manipulation.">
        </button>
      </section>
    </header>
    <section class="similarity_overview_parent" tabindex="0"
      [ariaLabel]="'Document has ' + (totalCharReplacements + totalWhiteCharacters + totalManipulatedImages) + ' Manipulations'">
      <section class="similarity_overview">
        <div class="overview-head">
          <div *ngIf="originalityDisplay !== 'None'" class="overview-tag">

            <h3 *ngIf="originalityDisplay !== 'riskFactor'" class="tag"
              [ngClass]="(totalCharReplacements + totalWhiteCharacters + totalManipulatedImages) == 0 ? 'low' : 'high'">
              <span class="round"></span>
              {{ totalCharReplacements + totalWhiteCharacters + totalManipulatedImages }}
            </h3>

            <h3 *ngIf="originalityDisplay === 'riskFactor'" class="tag"
              [ngClass]="(this.totalCharReplacements + this.totalWhiteCharacters + this.totalManipulatedImages) > 0 ? 'high' : 'low'">
              <span class="round"></span>
              {{ (this.totalCharReplacements + this.totalWhiteCharacters + this.totalManipulatedImages) > 0 ? 'High
              Risk' : 'Low Risk' }}
            </h3>

          </div>

          <img src="../../../../../../assets/report_v2/flag_borderless.svg" alt="">
          <section class="overview">
            <div tabindex="0"><span>{{ 'new_entries.character_replacement' | translate }}:</span><span class="answ">{{
                totalCharReplacements }}</span></div>
            <div tabindex="0"><span>{{ 'new_entries.hidden_text' | translate }}:</span><span class="answ">{{
                totalWhiteCharacters }}</span></div>
            <div tabindex="0"><span>{{ 'new_entries.image_in_place_of_text' | translate }}:</span><span class="answ">{{
                totalManipulatedImages }}</span></div>
          </section>
        </div>
        <section class="show_more" (click)="toggleTopFlags()">
          <button [ngClass]="showTopFlags ? 'rotate' : ''"><img src="../../../../../../assets/report_v2/arrow_down.svg"
              alt="Arrow Down">{{ showTopFlags ? 'Show less' : 'Show more' }}</button>
        </section>
      </section>
      <section class="top_flags" [ngClass]="showTopFlags ? 'open' : ''">
        <section class="top_flags_header">
          <h4>{{ 'new_entries.top_flags' | translate }} ({{ selectedFilterText }})</h4>
          <button (click)="toggleSummaryMenu()" class="sources_menu_btn">
            <img src="../../../../../../assets/report_v2/three-dots.svg" alt="Three Dots">
            <section *ngIf="isSummaryMenuOpen" class="sources_menu" cdkTrapFocus>
              <button class="sources_menu_opt" aria-label="Click to Show matching manipulations"
                (click)="filterManipulations(0)">{{ 'new_entries.show_top_flags' | translate }}</button>
              <button class="sources_menu_opt" aria-label="Click to Show only Character Replacements"
                (click)="filterManipulations(1)">{{ 'new_entries.show_only_character_replacements' | translate
                }}</button>
              <button class="sources_menu_opt"
                aria-label="Click to show only {{ 'new_entries.hidden_text' | translate }}"
                (click)="filterManipulations(2)">{{ 'new_entries.show_only_hidden_text' | translate }}</button>
              <button class="sources_menu_opt" aria-label="Click to show only Image in place  of text"
                (click)="filterManipulations(3)">{{ 'new_entries.show_only_images_in_place_of_text' | translate
                }}</button>
              <button class="sources_menu_opt" aria-label="Click to show excluded 'Characters'"
                (click)="filterManipulations(4)">{{ 'new_entries.show_excluded_characters' | translate }}</button>
              <button class="sources_menu_opt"
                aria-label="Click to show excluded '{{ 'new_entries.hidden_text' | translate }}'"
                (click)="filterManipulations(5)">{{ 'new_entries.show_excluded_hidden_text' | translate }}</button>
              <button class="sources_menu_opt" aria-label="Click to show red flags of 'Image in place of text'"
                (click)="filterManipulations(6)">{{ 'new_entries.show_green_flags_images' | translate }}</button>
              <button class="sources_menu_opt" aria-label="Click to show green flags of 'Image in place of text'"
                (click)="filterManipulations(7)">{{ 'new_entries.show_red_flags_images' | translate }}</button>
            </section>
          </button>
        </section>
        <section class="top_manipulations">
          <ng-container *ngIf="topManipulations?.charReplacements && topManipulations?.charReplacements.length >= 0">
            <section class="content" *ngFor="let manipulation of topManipulations?.charReplacements"
              [ngClass]="isCharReplacementExcluded(manipulation) ? 'excluded' : ''">
              <section class="head">
                <img src="../../../../../../assets/report_v2/flag_grey.svg" alt="">
                <p>{{ 'new_entries.character_replacement' | translate }}</p>
                <button *ngIf="canEdit"
                  (click)="toggleOneReplacedChar(manipulation, isCharReplacementExcluded(manipulation) ? 2 : 1)"><img
                    src="../../../../../../assets/report_v2/close-circle.svg" alt="Remove Manipulation"></button>
              </section>
              <section class="body">
                <p><span>{{ 'new_entries.character' | translate }}:</span>{{ manipulation.character }}</p>
                <p><span>{{ 'new_entries.appearance' | translate }}:</span>{{ manipulation.count }}</p>
              </section>
            </section>
            <span class="no_manipulations"
              *ngIf="topManipulations?.charReplacements.length == 0 && !topManipulations?.whiteCharacters && !topManipulations?.images">There
              are no manipulations that match this filter!</span>
          </ng-container>
          <ng-container *ngIf="topManipulations?.whiteCharacters && topManipulations?.whiteCharacters.length >= 0">
            <section class="content" *ngFor="let manipulation of topManipulations?.whiteCharacters"
              [ngClass]="manipulation.whitecharactersExcluded ? 'excluded' : ''">
              <section class="head">
                <img src="../../../../../../assets/report_v2/flag_grey.svg" alt="">
                <p>White Characters</p>
                <button *ngIf="canEdit" (click)="toggleWhiteCharSentence(manipulation)"><img
                    src="../../../../../../assets/report_v2/close-circle.svg" alt="Remove Manipulation"></button>
              </section>
              <section class="body">
                <p>{{ manipulation.text }}</p>
              </section>
            </section>
            <span class="no_manipulations"
              *ngIf="topManipulations?.whiteCharacters.length == 0 && !topManipulations?.charReplacements && !topManipulations?.images">There
              are no manipulations that match this filter!</span>
          </ng-container>

          <ng-container *ngIf="topManipulations?.images && topManipulations?.images.length > 0">
            <section class="content" [ngClass]="isCharReplacementExcluded(manipulation) ? 'excluded' : ''">
              <section class="imagesFilter">
                <div>
                  <img src="../../../../../../assets/report_v2/flag_grey.svg" alt="">
                  <p>{{ 'new_entries.image_in_place_of_text' | translate }}</p>
                </div>
                <ng-container *ngIf="topManipulations?.images && topManipulations?.images.length > 0">
                  <div class="content" [ngClass]="image.label === 'red' ? 'red' : 'green'"
                    *ngFor="let image of topManipulations.images"
                    (click)="selectSentence($event); scrollPage(image.page + 1)">
                    <img src="../../../../../../assets/report_v2/flag_grey.svg" alt="">
                    <section class="content-body">
                      <h6>{{ 'new_entries.flag' | translate }}</h6>
                      <p>Image {{ image.index }}</p>
                    </section>
                  </div>
                </ng-container>
              </section>
            </section>

            <span class="no_manipulations"
              *ngIf="topManipulations?.images.length == 0 && !topManipulations?.charReplacements && !topManipulations?.whiteCharacters">There
              are no manipulations that match this filter!</span>

          </ng-container>
        </section>
      </section>
    </section>
  </section>
</ng-template>